import React, { useState } from 'react';
import { Star, Quote, ArrowLeft, ArrowRight } from 'lucide-react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Vikram Nair',
    role: 'CTO, FinVault Technologies',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    review: 'GO Technology completely transformed our legacy banking platform into a modern, cloud-native system. The team\'s technical depth is extraordinary — they understood our regulatory constraints and delivered a solution that exceeded every expectation. Our transaction processing speed improved by 400%.',
    rating: 5,
    company: 'FinTech',
  },
  {
    name: 'Meera Krishnan',
    role: 'Founder & CEO, MedConnect',
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
    review: 'We engaged GO Technology for a full-stack healthcare platform with complex compliance requirements. Their expertise in HIPAA-compliant architecture and their ability to manage ambiguity in healthcare workflows was genuinely impressive. The platform now serves 50,000+ patients monthly.',
    rating: 5,
    company: 'HealthTech',
  },
  {
    name: 'Deepak Agarwal',
    role: 'VP Technology, RetailMax Group',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
    review: 'The e-commerce platform GO Technology built handles our peak season loads effortlessly. What stood out was their proactive approach — they identified potential bottlenecks before they became problems. Professional, transparent, and technically excellent.',
    rating: 5,
    company: 'E-Commerce',
  },
  {
    name: 'Anjali Desai',
    role: 'Director of Operations, EduLearn India',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
    review: 'Working with GO Technology on our EdTech platform was one of the best technology decisions we\'ve made. They brought a product mindset, not just a developer mindset. The result is an intuitive, scalable learning platform that\'s now used by over 200 schools.',
    rating: 5,
    company: 'EdTech',
  },
  {
    name: 'Rohan Kapoor',
    role: 'CEO, LogiFleet Systems',
    img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&q=80',
    review: 'GO Technology delivered our real-time fleet management system on time, under budget, and with features we didn\'t even know we needed. Their team anticipated our operational challenges and built solutions before we asked. Exceptional partnership.',
    rating: 5,
    company: 'Logistics',
  },
  {
    name: 'Preethi Rao',
    role: 'Head of Digital, ConstructPro',
    img: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
    review: 'The IT consulting engagement with GO Technology helped us define a clear 3-year technology roadmap. Their strategic thinking, combined with technical execution, is rare. They don\'t just tell you what to do — they help you understand why and how.',
    rating: 5,
    company: 'Real Estate',
  },
];

const logos = ['FinVault', 'MedConnect', 'RetailMax', 'EduLearn', 'LogiFleet', 'ConstructPro'];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const prev = () => setActive(i => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setActive(i => (i + 1) % testimonials.length);

  const t = testimonials[active];

  return (
    <div className="testimonials-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Client Stories</span>
          <h1>What Our <span>Clients Say</span></h1>
          <p>Over 200 projects delivered. Here are the voices of the businesses we've had the privilege to serve.</p>
        </div>
      </section>

      {/* Featured Testimonial */}
      <section className="section">
        <div className="container">
          <div className="featured-testimonial">
            <div className="featured-quote-icon"><Quote size={32} /></div>
            <div className="featured-content">
              <div className="stars">
                {[...Array(t.rating)].map((_, i) => <Star key={i} size={18} fill="#c8a96e" color="#c8a96e" />)}
              </div>
              <blockquote key={active}>"{t.review}"</blockquote>
              <div className="featured-author">
                <img src={t.img} alt={t.name} />
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.role}</span>
                </div>
                <div className="company-badge">{t.company}</div>
              </div>
            </div>
            <div className="testimonial-nav">
              <button onClick={prev} aria-label="Previous"><ArrowLeft size={20} /></button>
              <div className="testimonial-dots">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    className={`dot${i === active ? ' active' : ''}`}
                    onClick={() => setActive(i)}
                    aria-label={`Go to testimonial ${i + 1}`}
                  />
                ))}
              </div>
              <button onClick={next} aria-label="Next"><ArrowRight size={20} /></button>
            </div>
          </div>
        </div>
      </section>

      {/* All Testimonials Grid */}
      <section className="section all-testimonials">
        <div className="container">
          <div className="section-header">
            <span className="section-label">All Reviews</span>
            <h2 className="section-title">Every Story <span>Matters</span></h2>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <div className="tcard card" key={i}>
                <div className="tcard-header">
                  <img src={t.img} alt={t.name} />
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </div>
                <div className="stars">
                  {[...Array(t.rating)].map((_, j) => <Star key={j} size={13} fill="#c8a96e" color="#c8a96e" />)}
                </div>
                <p>"{t.review.slice(0, 180)}..."</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Logos */}
      <section className="logos-section">
        <div className="container">
          <p className="logos-label">Trusted by growing companies across India</p>
          <div className="logos-row">
            {logos.map((l, i) => (
              <div className="logo-chip" key={i}>{l}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
